import { render, staticRenderFns } from "./OtherIncomeEditingSection.vue?vue&type=template&id=578bad88&scoped=true"
import script from "./OtherIncomeEditingSection.vue?vue&type=script&lang=js"
export * from "./OtherIncomeEditingSection.vue?vue&type=script&lang=js"
import style0 from "./OtherIncomeEditingSection.vue?vue&type=style&index=0&id=578bad88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578bad88",
  null
  
)

export default component.exports